import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import DrawerCollapseSubMenu from '@/leftDrawer/DrawerCollapseSubMenu';
import DrawerSubMenuItem from '@/leftDrawer/DrawerSubMenuItem';
import MenuIcon from '@/leftDrawer/MenuIcon';
import { cn } from '@/lib/utils';

const DrawerSubMenu = ({
  subMenu,
  handleSubMenuChange,
  handleCollapseSubMenuChange,
  subMenuToOpenByIndex,
}) => (
  <div className="text-white font-normal text-[12px]">
    <nav className="flex flex-col">
      {subMenu.map((subMenuOption, subMenuIndex) => {
        if (Array.isArray(subMenuOption.collapseSubMenu) && !!subMenuOption.collapseSubMenu.length) {
          const isOpenByDefault = Number.isInteger(subMenuToOpenByIndex)
            ? subMenuToOpenByIndex === subMenuIndex
            : subMenuIndex === 0;

          return (
            <DrawerCollapseSubMenu
              key={subMenuIndex}
              subMenuOption={{ ...subMenuOption, index: subMenuIndex }}
              collapseSubMenu={subMenuOption.collapseSubMenu}
              handleCollapseSubMenuChange={handleCollapseSubMenuChange}
              isOpenByDefault={isOpenByDefault}
            />
          );
        }

        return (
          <DrawerSubMenuItem key={subMenuIndex} content={subMenuOption.content}>
            <div
              className={cn(
                "flex cursor-pointer select-none items-center h-[48px] pl-[18px] pr-4 transition-all duration-200 hover:bg-white/5 hover:text-white",
                subMenuOption.active && "bg-[#1E2941] text-white border-l-[3px] border-white",
                subMenuOption.disabled && "cursor-not-allowed opacity-40 pointer-events-none"
              )}
              onClick={e => !subMenuOption.disabled && handleSubMenuChange(subMenuIndex, e, subMenuOption.routeLink)}
              data-cy={`${subMenuOption.key}-left-menu-option`}
            >
              <div className="min-w-[48px] shrink-0 opacity-70 group-hover:opacity-100">
                <MenuIcon menuKey={subMenuOption.key} />
              </div>
              <span className="tracking-wide text-[12px] font-normal">
                <FormattedMessage id={'LeftDrawer.' + subMenuOption.key} />
              </span>
            </div>
          </DrawerSubMenuItem>
        );
      })}
    </nav>
  </div>
);

DrawerSubMenu.propTypes = {
  /**
   * Array with the sub-menu options
   */
  subMenu: PropTypes.array.isRequired,
  /**
   * Function to change the selected sub-menu option
   */
  handleSubMenuChange: PropTypes.func.isRequired,
  /**
   * Function to handle the url change of the collapse-menu (submenu inside submenu)
   */
  handleCollapseSubMenuChange: PropTypes.func.isRequired,
  /**
   * Default submenu index to open (if it is provided)
   */
  subMenuToOpenByIndex: PropTypes.number,
};

DrawerSubMenu.defaultProps = {
  subMenuToOpenByIndex: null,
};

export default DrawerSubMenu;
